import React, {Component} from 'react'
import {chunk} from 'lodash'
import PropTypes from 'prop-types'
import Pagination from './Pagination'
import ClickToPlay from './ClickToPlay'
import './VideoList.css'

export default class VideoList extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    count: PropTypes.number.isRequired,
  }

  state = {
    items: [],
    current: 1,
    total: 0,
  }

  // data 变化（如切换 tab 重新随机切片）时回到第 1 页，
  // 用 Math.ceil 计算总页数，避免末尾不足一页时丢页
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data === nextProps.data) return
    const {data, count} = nextProps
    this.setState({
      items: data.slice(0, count),
      current: 1,
      total: Math.ceil(data.length / count),
    })
  }

  componentDidMount() {
    const {data, count} = this.props
    this.setState({
      items: data.slice(0, count),
      total: Math.ceil(data.length / count),
    })
  }

  // 1-based 页码切片：第 index 页取 [(index - 1) * count, index * count)
  handlePage = index => {
    const {count, data} = this.props
    this.setState({
      current: index,
      items: data.slice((index - 1) * count, index * count),
    })
  }

  renderItem(item, index) {
    const VideoRoot = 'https://v.vzuu.com/video/'
    const videoSrc = item.video_id ? `${VideoRoot}${item.video_id}` : item.src
    const cover = item.cover_url ? <img src={item.cover_url} alt="" /> : null
    return (
      // key 用视频 id 而非数组下标：翻页后避免 React 复用同一位置已播放的实例
      <div className="video-item" key={item.video_id || item.src || index}>
        <ClickToPlay
          src={videoSrc}
          width={344}
          height={212}
          title={item.title || ''}
          placeholder={cover}
        />
        <p className="video-itemTitle">{item.title ? item.title : ''}</p>
        <p className="video-itemCount">
          {item.play_count ? `当日播放量 ${item.play_count}` : ''}
        </p>
        {this.props.id === 2 && (
          <div
            className="video-item-mask"
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              window.alert('付费后方可观看，每条 2 元')
            }}
          />
        )}
      </div>
    )
  }

  render() {
    const {title} = this.props
    const {items, current, total} = this.state
    const groups = chunk(items, 3)
    return (
      <div className="VideoList">
        <h3 className="subtitle-page">{title}</h3>
        <div className="VideoList-content">
          {groups.map((group, index) => (
            <div className="video-group" key={index}>
              {group.map((item, itemIndex) => this.renderItem(item, itemIndex))}
            </div>
          ))}
        </div>
        {total > 1 && (
          <Pagination
            current={current}
            total={total}
            clickCallback={this.handlePage}
          />
        )}
      </div>
    )
  }
}
